import { render } from "./UnitField.vue?vue&type=template&id=8a4cde44"
import script from "./UnitField.vue?vue&type=script&lang=js"
export * from "./UnitField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__